import React from "react";
import { useInView } from "../lib/useInView";

/**
 * Reveal — fades + translates children into view when they enter the viewport.
 * Variants: "up" (default), "fade", "scale", "left", "right".
 * Delay in ms. Stagger via index.
 */
export default function Reveal({
  children,
  variant = "up",
  delay = 0,
  duration = 800,
  threshold = 0.15,
  className = "",
  as: Tag = "div",
  ...rest
}) {
  const { ref, inView } = useInView({ threshold });

  const variants = {
    up: "translate-y-10",
    down: "-translate-y-10",
    fade: "",
    scale: "scale-95",
    left: "-translate-x-10",
    right: "translate-x-10",
  };

  const initial = variants[variant] || variants.up;

  return (
    <Tag
      ref={ref}
      data-revealed={inView ? "true" : "false"}
      className={`will-change-transform transition-all ease-out ${
        inView ? "opacity-100 translate-x-0 translate-y-0 scale-100" : `opacity-0 ${initial}`
      } ${className}`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: inView ? `${delay}ms` : "0ms",
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
